// extracted by mini-css-extract-plugin
export var button = "card-module--button--f7d9c";
export var buttonContainer = "card-module--buttonContainer--b4875";
export var card = "card-module--card--8fc10";
export var cardContent = "card-module--cardContent--7b91a";
export var date = "card-module--date--d7cf5";
export var title = "card-module--title--c9092";